import type { WriteMap } from "./character-edits.js";

export type WizardStep = "ruleset" | "scene" | "premise" | "done";

export interface WizardStateRecord {
  step: WizardStep;
  completed?: boolean;
  skippedScene?: boolean;
}

const ORDER: WizardStep[] = ["ruleset", "scene", "premise", "done"];

export function nextStep(current: WizardStep): WizardStep {
  const i = ORDER.indexOf(current);
  if (i < 0 || i === ORDER.length - 1) return "done";
  return ORDER[i + 1] ?? "done";
}

export function advanceWizard(tablePath: string, current: WizardStep): WriteMap {
  return { [`${tablePath}/meta/wizardState/step`]: nextStep(current) };
}

export function skipScenePack(tablePath: string): WriteMap {
  return {
    [`${tablePath}/meta/wizardState/step`]: "premise",
    [`${tablePath}/meta/wizardState/skippedScene`]: true,
  };
}

export function completeWizard(tablePath: string): WriteMap {
  return {
    [`${tablePath}/meta/wizardState/step`]: "done",
    [`${tablePath}/meta/wizardState/completed`]: true,
  };
}

export function isWizardComplete(state: WizardStateRecord | undefined): boolean {
  return state?.completed === true;
}
